import { FormControl, TextField } from "@mui/material";
import React, { useState } from "react";
import styles from "./styles";

export interface IOwnProps {
  label?: string;
  required?: boolean;
  type?: string;
  classes?: any;
  size?: number;
  maxLength?: number;
  max?: number;
  min?: number;
  handleChange?(id: string | number, value: string | number): void;
  id?: string;
  defaultValue?: string | number | Date;
  disabled?: boolean;
  multiline?: boolean;
  placeholder?: string;
  rows?: number;
}

const UncontrolledInputField = ({
  label,
  required,
  type,
  size,
  maxLength,
  max,
  min,
  handleChange,
  id,
  defaultValue,
  disabled,
  multiline,
  placeholder,
  rows,
}: IOwnProps) => {
  const [value, setValue] = useState<string | number | undefined>(undefined);
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let val: string | number = event.target.value;

    const minVal = min || 0;

    if (val && max && type === "number" && parseInt(val, 0) > max) {
      val = max;
    }
    if (val && type === "number" && parseInt(val.toString(), 0) < minVal) {
      val = minVal;
    }
    setValue(val);
    if (handleChange) {
      handleChange(event.target.id, val);
    }
  };

  return (
    <FormControl className={"root"} sx={styles}>
      <TextField
        id={id}
        value={value}
        label={label}
        disabled={disabled}
        required={required}
        className={"textFieldRoot"}
        onChange={onChange}
        multiline={multiline}
        placeholder={placeholder}
        rows={rows}
        InputProps={{
          classes: {
            input: "textField",
            underline: "underline",
          },
        }}
        inputProps={{ size, maxLength, min, max }}
        InputLabelProps={{
          classes: {
            root: "textFieldLabel",
            focused: "textFieldLabelFocused",
            error: "textFieldLabelError",
            asterisk: "textFieldLabelAsterisk",
          },
        }}
        variant="filled"
        defaultValue={defaultValue}
        type={type ? type : "text"}
      />
    </FormControl>
  );
};

export default UncontrolledInputField;
